import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-configuration-delete-confirmation-dialog',
    templateUrl: './activate-deactivate-confirmation-dialog.component.html',
    styleUrls: ['./activate-deactivate-confirmation-dialog.component.scss'],
    standalone: false
})
export class ActivateDeactivateConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }
  statusForConfirmation: { statusForConfirmation: string };
  ngOnInit(): void {
    console.log(this.statusForConfirmation.statusForConfirmation);
  }

  activateDeactivateConfiguration() {
    this.activeModal.close(true);
  }


  close() {
    this.activeModal.close(false);
  }

}
